<script setup>
import { ref } from "vue";
import { Head, Link, router, useForm, usePage } from "@inertiajs/vue3";
import VButtonSubmit from "@/Shared/Buttons/VButtonSubmit";
import VInputWithLabel from "@/Shared/Form/VInputWithLabel.vue";
import VSelectWithLabel from "../../Shared/Form/VSelectWithLabel.vue";
import VAlert from "@/Shared/VAlert.vue";
import VDevider from "@/Shared/VDevider.vue";
import VHeaderBreadcrumb from "@/Shared/VHeaderBreadcrumb.vue";
import VTitleWithBackLink from "@/Shared/VTitleWithBackLink.vue";

const props = defineProps({
    title : String,
    additional: Object
});

const form = useForm({
    code: props.additional.surveyResearcher.code,
    user : props.additional.surveyResearcher.user_id,
    survey: props.additional.surveyResearcher.survey_template_id,
    _method: "PUT",
});

const breadcrumbs = [
    {
        url: props.additional.urlIndex,
        label: "Survey Researcher",
    },
    {
        url: "#",
        label: "Edit Survey Researcher",
    },
];

const submit = () => {
    form.post(props.additional.urlSubmit, {
        preserveScroll: true
    });
};

</script>

<template>
    <Head>
        <title>{{ title }}</title>
    </Head>

    <div class="p-3">
        <VHeaderBreadcrumb :breadcrumbs="breadcrumbs" />

        <div class="card">
            <div class="card-body">
                <div class="d-flex justify-content-between">
                    <VTitleWithBackLink
                        :href="additional.urlIndex"
                        :filters="additional.filters ?? {}"
                    >
                        Edit Survery Researcher
                    </VTitleWithBackLink>
                </div>
                <VDevider />
                <VAlert />
                <form @submit.prevent="submit">
                    <div class="row">
                        <div class="col-lg-6 mb-3">
                            <VInputWithLabel
                                elId="code"
                                label="Code"
                                type="text"
                                :error="form.errors.code"
                                v-model:value="form.code"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-6 mb-3">
                            <VSelectWithLabel
                                elId="user"
                                label="Researcher"
                                v-model:value="form.user"
                                :error="form.errors.user"
                                :options="additional.users"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-6 mb-3">
                            <VSelectWithLabel
                                elId="survey"
                                label="Survey Template"
                                v-model:value="form.survey"
                                :error="form.errors.survey"
                                :options="additional.surveyTemplate"
                            />
                        </div>
                    </div>

                    <div class="text-end">
                        <VButtonSubmit
                            type="submit"
                            :isProcessing="form.processing"
                        >
                            Submit
                        </VButtonSubmit>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
